<template>
  <div
    :class="[
      'page',
      { 'flex space_between': !ismobile },
      { 'm_bg text_center': ismobile },
    ]"
  >
    <div :class="[ismobile ? 'm_login' : 'login']">
      <h2 style="color: #6366f9">魔法英语背单词</h2>
      <h2 style="color: #6366f9">欢迎登录</h2>
      <el-form ref="formRef" :model="form" label-width="0" style="width: 300px">
        <el-form-item
          v-if="nicknameShow"
          label=""
          prop="nickName"
          :rules="[
            {
              required: true,
              message: '请输入姓名',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            style="width: 100%"
            v-model="form.nickName"
            placeholder="请输入姓名"
            size="large"
          />
        </el-form-item>
        <el-form-item
          prop="phone"
          :rules="[
            {
              required: true,
              message: '请输入手机号',
              trigger: 'blur',
            },
          ]"
        >
          <el-row style="width: 100%">
            <el-col :span="24">
              <el-input
                style="width: 100%"
                v-model="form.phone"
                placeholder="请输入手机号"
                size="large"
            /></el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          prop="code"
          :rules="[
            {
              required: true,
              message: '请输入验证码',
              trigger: 'blur',
            },
          ]"
        >
          <el-row style="width: 100%">
            <el-col :span="14">
              <el-input
                style="width: 100%"
                v-model="form.code"
                placeholder="请输入验证码"
                size="large"
            /></el-col>
            <el-col :span="10">
              <el-button
                style="width: 100%"
                round
                size="large"
                @click="getCode"
                >{{ sendCon }}</el-button
              >
            </el-col>
          </el-row>
        </el-form-item>
        <br />
        <br />
        <el-form-item>
          <el-button
            style="width: 100%"
            color="#6366F9"
            @click="onSubmit(formRef)"
            size="large"
            round
            :loading="loading"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <img v-if="!ismobile" src="../assets/images/login.png" alt="" />
  </div>
</template>

<script setup>
import { reactive, ref, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { post, get } from "../request/post";
const router = useRouter();
const formRef = ref();
const form = ref({});
const ismobile = ref(false);
const loading = ref(false);
const sendCon = ref("获取验证码");
const nicknameShow = ref(false);
const isCode = ref(false);
const timer = ref(null);
const state = reactive({});
onMounted(() => {
  if (router.currentRoute._value.params.type == 1) {
    nicknameShow.value = true;
  }
  ismobile.value = isMobile();
  function isMobile() {
    let userAgent = navigator.userAgent;
    return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  }
});

const onSubmit = async () => {
  if (!formRef) return;
  formRef.value.validate((valid) => {
    if (valid) {
      loading.value = true;
      Login();
    }
  });
};
const Login = async () => {
  const { data, code, msg } = await post("/mf/login", form.value);
  loading.value = false;
  if (code == 200) {
    console.log(data);
    localStorage.setItem("data", JSON.stringify(data));
    router.push({
      name: "Word",
    });
  } else {
    ElMessage.error(msg);
    return;
  }
};
const getCode = async () => {
  if (!form.value.phone) {
    return false;
  }
  if (isCode.value) {
    return;
  }
  isCode.value = true;
  const { data, code, message } = await post("/mf/send_code", {
    phone: form.value.phone,
  });
  isCode.value = false;
  if (code == 200) {
    ElMessage.success("发送成功");
    countdown();
  } else {
    ElMessage.error(message);
  }
};
const countdown = () => {
  const TIME_COUNT = 60;
  let count = 0;
  if (!timer.value) {
    count = TIME_COUNT;
    timer.value = setInterval(() => {
      if (count > 0 && count <= TIME_COUNT) {
        isCode.value = true;
        count--;
        sendCon.value = `${count}秒后再次获取`;
      } else {
        isCode.value = false;
        clearInterval(timer.value);
        timer.value = null;
        sendCon.value = "获取验证码";
      }
    }, 1000);
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background-color: #fff;
}

.welcome {
  color: #6366f9;
  padding-left: 10px;
  padding-top: 20px;
}

.login {
  margin: auto;
  margin-left: 30%;
}
.m_login {
  margin: 0 auto;
  padding-top: 20%;
  width: 80%;
}
/* .el-input {
  width: 270px;
}
.el-button {
  width: 270px;
} */
:deep(.el-input__wrapper) {
  border-radius: 20px;
}
.m_bg {
  background: url("../assets/images/m_login.jpg");
  /* background-size: 100% 100%; */
  background-size: cover;
}
</style>
